export const PRESENTATION_TYPE = {
    PRIVATE: 'private',
    PUBLIC: 'public',
};
export const LOGO_SET_BLOCK_TYPE = {
    PROFILE: 'profile',
    COMPANY: 'company',
};
